const addressSelect = document.getElementById("addressSelect");

document.addEventListener("DOMContentLoaded", async () => {
    if (addressSelect) {

        const savedZip = await vertiv.storage.get("selectAddressId")
        if (savedZip) {
            select.value = savedZip
        }

        addressSelect.addEventListener("change", addressChangeHandler);
        showSelectedAddress();
    }
});

const addressChangeHandler = async () => {

    const selectedOption = addressSelect.options[addressSelect.selectedIndex];
    const selectedZipcode = selectedOption.value;
    vertiv.storage.set('selectedAddressId', selectedZipcode);

    await renderDealers(selectedZipcode);
}

const showSelectedAddress = async () => {
    const savedAddressZip = vertiv.storage.get('selectedAddressId');
    addressSelect.value = savedAddressZip;
    await renderDealers(savedAddressZip);
}